module.exports = function () {

    // footer header toggle
    $('.main-footer__nav__header-toggle').click(function (e) {
        e.preventDefault();

        var $groupToToggle = $(this).parent().siblings('.main-footer__nav__groups').first();

        if ($(this).hasClass('main-footer__nav__header-toggle--is-active')) {
            $(this).removeClass('main-footer__nav__header-toggle--is-active');
            $groupToToggle.css({
                height: '0px'
            });
        }
        else {
            var height = 0;
            $groupToToggle.find('.main-footer__nav__group').each(function (i) {
                height += $(this).outerHeight(true);
            });

            $(this).addClass('main-footer__nav__header-toggle--is-active');
            $groupToToggle.css({
                height: height + 'px'
            });
        }

        updateFooterAccessibilityElements();
    });

    var checkFooterNavigationGroupsForSocialLinks = function () {
        $('.main-footer__nav__groups').each(function (i, el) {
            var $container = $(this).find('.main-footer__social-link-items-container');

            if (!$container.length) {
                $(this).addClass('main-footer__nav__groups--without-social-links')
            }
        });
    };

    var resetFooterHeights = function () {
        if (window.innerWidth > 767) {
            $('.main-footer__nav__groups').css({
                height: ''
            });

            $('.main-footer__nav__header-toggle').removeClass('main-footer__nav__header-toggle--is-active');
        }
    };

    // update aria and tabindex properties of footer elements
    var updateFooterAccessibilityElements = function () {        
        if (window.innerWidth < 768) {
            $('.main-footer__nav__header-toggle').not('.main-footer__nav__header-toggle--is-active').attr('aria-expanded', false);
            $('.main-footer__nav__header-toggle--is-active').attr('aria-expanded', true);

            $('.main-footer__nav__header').each(function () {

                var $navHeader = $(this).find('.main-footer__nav__header-toggle');

                if ($navHeader) {
                    var $navGroups = $(this).next('.main-footer__nav__groups--without-social-links');

                    if ($navHeader && $navHeader.hasClass('main-footer__nav__header-toggle--is-active')) {
                        $navGroups.removeAttr('aria-hidden');
                        $navGroups.find('a').attr('tabindex', '');
                    }
                    else {
                        $navGroups.attr('aria-hidden', true);
                        $navGroups.find('a').attr('tabindex', '-1');
                    }
                }
            });
        }
        else {
            $('.main-footer').find('a').not('.main-footer__social-link-icon').attr('tabindex', '');
        }
    };

    $(window).resize(function () {
        requestAnimationFrame(resetFooterHeights);

        updateFooterAccessibilityElements();
    });

    checkFooterNavigationGroupsForSocialLinks();
    updateFooterAccessibilityElements();
};